'use strict';
import {getUserId} from '../../../auth/reducers';
import {getCollection, getId} from '../../../core-utilities/domain/ReduxUtils';
import {COLLECTION as FILE_ASSET_COLLECTION} from './FileAssetDomain';
import {COLLECTION as FILE_FULFILLMENT_COLLECTION} from './FileFulfillmentDomain';


export function canAddFile(status) {
  switch (status) {
    case 'pending':
    case 'in_progress':
    case 'submitted':
    case 'rejected':
      return 'requirement_submission_edit';
    case 'approved':
      return 'requirement_approval_edit';
    case 'cancelled':
    default:
      return null
  }
}

export function canAddAssetFile(status) {
  return `asset_${canAddFile(status)}`;
}

export function AbstractFileRequirementProvider() {
  return {
    $get: [
      '$injector',
      '$ngRedux',
      'FirebaseUtil',
      'AbstractDomainClass',
      '$$AbstractRequirement',
      'FirebaseQueueService',
      'ROOT_API_COLLECTION',
      'ROOT_API_SPEC',
      function (
        $injector,
        $ngRedux,
        FirebaseUtil,
        AbstractDomainClass,
        $$AbstractRequirement,
        FirebaseQueueService,
        ROOT_API_COLLECTION,
        ROOT_API_SPEC,
      ) {

        function AbstractFileRequirement() {
          //AbstractDomainClass.call(this, Class, data); // args: Class, data
        }

        AbstractFileRequirement.__inheritFrom = function (Class, className, collection, config) {
          $$AbstractRequirement.__inheritFrom(Class, className, collection, config);

          Class.$constraints.addConstraints({
            type: {type: 'Domain', domainClass: 'RequirementTypeDomain', nullable: true},

            /* Requirement Constraints */
            minimumFileCount: {type: 'number', minValue: 0, defaultValue: 1},
            maximumFileCount: {type: 'number', minValue: 1, defaultValue: 1},
            countIsEnforced: {type: 'boolean', defaultValue: false}, // Display as 'Enforce Range' was allowMoreThanMaximum but functionality inverted

            files: {type: 'DomainCollection', domainClass: 'FileFulfillmentDomain', link: 'requirement'}
          });

          Class.canAddFile = collection.indexOf('asset') > -1 ? canAddAssetFile : canAddFile;

          Class.$replaceAsset = AbstractFileRequirement.$replaceAsset;
          Class.$addFileDomain = AbstractFileRequirement.$addFileDomain;
          Class.$getName = AbstractFileRequirement.$getName;
          Class.$generateFileRequest = $generateFileRequestStatic;

          //Class.prototype << AbstractFileRequirement.prototype
          Class.prototype.$getName = AbstractFileRequirement.prototype.$getName;
          Class.prototype.$replaceAsset = AbstractFileRequirement.prototype.$replaceAsset;
          Class.prototype.$addFileDomain = AbstractFileRequirement.prototype.$addFileDomain;
          Class.prototype.$generateFileRequest = $generateFileRequestProto;

          function $generateFileRequestStatic(requirement, fileFulfillment) {
            const fulfillmentId = fileFulfillment ? getId(fileFulfillment) : FirebaseUtil.generateKey();
            const assetId = FirebaseUtil.generateKey();

            return {
              path: `${Class.$getPath(requirement)}/${fulfillmentId}/${assetId}`,
              firebasePath: `${Class.$getCollectionPath(requirement)}/${FILE_FULFILLMENT_COLLECTION}/${FILE_ASSET_COLLECTION}`,
              filename: Class.$getName(requirement)
            };
          }

          function $generateFileRequestProto(fileFulfillment) {
            return $generateFileRequestStatic(this, fileFulfillment);
          }
        };

        //Class methods go here

        AbstractFileRequirement.$addFileDomain = function $addFileDomainStatic(id, fileDomain) {
          if (!fileDomain) return Promise.reject(`${this.name}.$addFileDomain missing required argument fileDomain`);

          const FileDomain = $injector.get('FileDomain');
          const fileId = FileDomain.getFileId(fileDomain);
          const method = this.COLLECTION.indexOf('asset') > -1
            ? 'asset-requirements/files/add-file'
            : 'requirements/files/add-file';

          const request = {
            method: method,
            requirementId: id,
            fileId: fileId
          };

          const userId = getUserId($ngRedux.getState());
          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        AbstractFileRequirement.$replaceAsset = function $replaceAssetStatic(requirementId, fulfillmentId, fileDomain) {
          if (!fileDomain || !fulfillmentId) return Promise.reject(`${this.name}.$replaceAsset missing required argument fileDomain or fulfillmentId`);

          const FileDomain = $injector.get('FileDomain');
          const fileId = FileDomain.getFileId(fileDomain);
          const method = this.COLLECTION.indexOf('asset') > -1
            ? 'asset-requirements/files/replace-file'
            : 'requirements/files/replace-file';

          const request = {
            method: method,
            requirementId: requirementId,
            fulfillmentId: fulfillmentId,
            fileId: fileId
          };

          const userId = getUserId($ngRedux.getState());
          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        //AbstractFileRequirement.prototype methods go here

        /**
         * Creates a new file fulfillment with corresponding current file asset using the IDs that were generated for the specified fileDomain
         *
         * TODO: add support for other means of passing the fileDomain reference and retrieving it before parsing its path field
         *
         * @param fileDomain
         * @returns {Promise}
         */
        AbstractFileRequirement.prototype.$addFileDomain = function $addFileDomain(fileDomain) {
          const method = getCollection(this).indexOf('asset') > -1
            ? 'asset-requirements/files/add-file'
            : 'requirements/files/add-file';

          const request = {
            method: method,
            requirementId: getId(this),
            fileId: getId(fileDomain),
          };

          const userId = getUserId($ngRedux.getState());
          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        AbstractFileRequirement.prototype.$replaceAsset = function $replaceAsset(fulfillment, fileDomain) {
          const method = getCollection(this).indexOf('asset') > -1
            ? 'asset-requirements/files/replace-file'
            : 'requirements/files/replace-file';

          const request = {
            method: method,
            requirementId: getId(this),
            fulfillmentId: getId(fulfillment),
            fileId: getId(fileDomain),
          };

          const userId = getUserId($ngRedux.getState());
          return FirebaseQueueService.addTask(request, userId, ROOT_API_COLLECTION, ROOT_API_SPEC);
        };

        AbstractFileRequirement.$getName = getName;

        AbstractFileRequirement.prototype.$getName = function (currentFileCount) {
          return getName(this.name, currentFileCount);
        };

        return AbstractFileRequirement;
      }]
  };
}

export function getName(name, currentFileCount) {
  return name + (currentFileCount ? ` (${currentFileCount + 1})` : '');
}



// WEBPACK FOOTER //
// ./src/js/requirements/domain/files/AbstractFileRequirement.js